import React, { useContext } from 'react';
import { withRouter, Redirect } from 'react-router';

import firebase from '../../firebase/base';
import { AuthContext } from '../../contexts/auth.context';

import Button from '../button/Button';

import { Form, ChangeMethod } from './SignIn.styles';

const SignIn = ({ setSignInUp }) => {
  const handleLogin = event => {
    event.preventDefault();
    const { email, password } = event.target.elements;

    firebase
      .auth()
      .signInWithEmailAndPassword(email.value, password.value)
      .catch(err => {
        alert(err);
      });
  };

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    return <Redirect to="/favorites" />;
  }

  return (
    <div>
      <Form onSubmit={handleLogin}>
        <h1>Sign in</h1>
        <span>And enjoy your podcasts.</span>
        <input name="email" type="email" placeholder="Email" />
        <input name="password" type="password" placeholder="Password" />
        <Button>Sign in</Button>
        <ChangeMethod onClick={() => setSignInUp(false)}>Join Now</ChangeMethod>
      </Form>
    </div>
  );
};

export default withRouter(SignIn);
